export const allowedCodes = ['01', '02', '03', '04', '05']
